// extracted by mini-css-extract-plugin
module.exports = {"form__control":"inputs_form__control__EpU85","input":"inputs_input__RfaHz"};